import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import DataTable from 'examples/Tables/DataTable'
import MDButton from 'components/MDButton'
import MDAlert from 'components/MDAlert'
import { Tooltip, IconButton } from '@mui/material'

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'

import CrudService from 'services/cruds-service'
import { AbilityContext } from 'Can'
import { useAbility } from '@casl/react'

function SubscriptionPlan() {
  let { state } = useLocation()
  const ability = useAbility(AbilityContext)
  const [data, setData] = useState([])
  const [notification, setNotification] = useState({
    value: false,
    text: '',
  })

  const navigate = useNavigate()

  useEffect(() => {
    ; (async () => {
      const response = await CrudService.getSubscriptionPlanList()
      setData(response.data)
    })()
    document.title = `Rivio | Subscription Plan`
  }, [])

  useEffect(() => {
    if (!state) return
    setNotification({
      value: state.value,
      text: state.text,
    })
  }, [state])

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: '',
        })
      }, 5000)
    }
  }, [notification])

  const clickAddHandler = () => {
    navigate('/subscription-plan/new')
  }

  const clickEditHandler = (id) => {
    navigate(`/subscription-plan/edit/${id}`)
  }

  const clickDeleteHandler = async (e, id) => {
    try {
      if (!confirm('Are you sure you want to delete this plan?')) {
        e.nativeEvent.stopImmediatePropagation()
      } else {
        let reseponse = await CrudService.removeSubscriptionPlan(id)
        if(!reseponse.success){
          setNotification({
            value: true,
            text: reseponse.error,
          })
          return
        }
        // the delete does not send a response
        // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
        const response = await CrudService.getSubscriptionPlanList()
        setData(response.data)
        setNotification({
          value: true,
          text: 'The Subscription Plan has been successfully deleted',
        })
      }
    } catch (err) {
      // it sends error is the Contact is associated with an Contact
      console.error(err)
      setNotification({
        value: true,
        text: err.error,
      })
      return null
    }
  }

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {

      return {
        type: 'subscription_plan',
        id: row.plan_id,
        plan_name: row.plan_name,
        billing_cycle: row.billing_cycle,
        description: row.description,
        price_per_device: row.price_per_device,
      }
    })
    return updatedInfo
  }

  const columns = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'plan_name' },
    { Header: 'Billing Cycle', accessor: 'billing_cycle' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Price Per Device', accessor: 'price_per_device' },
    {
      Header: 'actions',
      disableSortBy: true,
      accessor: '',
      Cell: (info) => {
        return (
          <MDBox display="flex" alignItems="center" >
            {
              ability.can('edit', 'contacts') && (
                <Tooltip title="Edit Plan">
                  <IconButton
                    onClick={() => clickEditHandler(info.cell.row.original.id)}
                  >
                    <MDTypography>
                      <EditIcon />
                    </MDTypography>
                  </IconButton>
                </Tooltip>
              )
            }
            {ability.can('delete', 'contacts') && (
              <Tooltip title="Delete Plan">
                <IconButton
                  onClick={(e) =>
                    clickDeleteHandler(e, info.cell.row.original.id)
                  }
                >
                  <MDTypography>
                    <DeleteIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            )
            }
          </MDBox >
        )
      },
    },
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text || ''}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pt={1}>
        <MDBox>
          <Card>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium">
                Plan List
              </MDTypography>
              <MDButton
                variant="gradient"
                color="dark"
                size="small"
                type="submit"
                onClick={clickAddHandler}
              >
                + Add Plan
              </MDButton>
            </MDBox>
            <DataTable table={{ columns, rows: getRows(data) }} canSearch={true} />
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default SubscriptionPlan
